import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { PaletteContainerComponent } from "@lantern/app/common/wayfarer/container/container-attributes";

import {
  ExpContainerComponent,
  ExpContainerDirective
} from "./exp-container.component";

@NgModule({
  imports: [CommonModule],
  declarations: [ExpContainerComponent, PaletteContainerComponent, ExpContainerDirective],
  exports: [
    ExpContainerComponent,
    PaletteContainerComponent,
    ExpContainerDirective
  ]
})
export class ExpContainerModule {}
